import React from 'react'
import Logo from '../etea-logo.svg'
import { Link } from "react-router-dom";

const Header = () => {
  const styles = {
    header: {
      background: '#ffffff',
      padding: '15px 5%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
      flexWrap: 'wrap', // Ensures it wraps on very small screens
      borderBottom: '3px solid #007bff'
    },
    logoSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      flex: '1',
    },
    logo: {
      height: '70px',
      width: 'auto',
    },
    textSection: {
      display: 'flex',
      flexDirection: 'column',
    },
    mainHeading: {
      fontSize: '1.4rem',
      fontWeight: '700',
      color: '#2c3e50',
      margin: 0,
      letterSpacing: '0.5px'
    },
    subHeading: {
      fontSize: '1rem',
      fontWeight: '500',
      color: '#007bff',
      margin: 0,
      textTransform: 'uppercase',
      letterSpacing: '1px'
    },
    buttonSection: {
      display: 'flex',
      alignItems: 'center'
    },
    homeBtn: {
      backgroundColor: '#007bff',
      color: '#fff',
      border: 'none',
      padding: '10px 24px',
      borderRadius: '6px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }
  };

  return (
    <header style={styles.header} className="etea-online-header">
      <style>
        {`
          @media (max-width: 768px) {
            .etea-online-header {
              flex-direction: column;
              text-align: center;
              gap: 15px;
            }
            .logo-section {
              flex-direction: column;
              gap: 10px;
            }
          }
          .home-button-hover:hover {
            background-color: #0056b3 !important;
            transform: translateY(-1px);
            box-shadow: 0 4px 8px rgba(0,0,0,0.15) !important;
          }
        `}
      </style>

      {/* Logo and Text Group */}
      <div style={styles.logoSection} className="logo-section">
        <img src={Logo} style={styles.logo} className="etea-logo" alt="ETEA Logo" />

        <div style={styles.textSection}>
          <h1 style={styles.mainHeading}>
            Educational Testing & Evaluation Agency (ETEA)
          </h1>
          <h2 style={styles.subHeading}>
            Government of Khyber Pakhtunkhwa
          </h2>
        </div>
      </div>

      {/* Button Group */}
      <div style={styles.buttonSection} className="btn-header">
        <input
          className="home-button-hover"
          style={styles.homeBtn}
          type="button"
          value="Home Page"
          onClick={() => (window.location.href = "/")}
        />
      </div>
    </header>
  );
};

export default Header;